import React from 'react';
import { Clock, CheckCircle, XCircle, AlertTriangle } from 'lucide-react';
import type { AdvisorStatus } from '../../types/advisor';

interface AdvisorStatusBadgeProps {
  status: AdvisorStatus;
  className?: string;
}

export const AdvisorStatusBadge: React.FC<AdvisorStatusBadgeProps> = ({
  status,
  className = ''
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'PENDING':
        return {
          icon: Clock,
          label: 'En attente',
          className: 'bg-orange-100 text-orange-800 border-orange-200'
        };
      case 'ACTIVE':
        return {
          icon: CheckCircle,
          label: 'Actif',
          className: 'bg-green-100 text-green-800 border-green-200'
        };
      case 'SUSPENDED':
        return {
          icon: AlertTriangle,
          label: 'Suspendu',
          className: 'bg-orange-100 text-orange-800 border-orange-200'
        };
      case 'REJECTED':
        return {
          icon: XCircle,
          label: 'Refusé',
          className: 'bg-red-100 text-red-800 border-red-200'
        };
      default:
        return {
          icon: Clock,
          label: 'Inconnu',
          className: 'bg-gray-100 text-gray-800 border-gray-200'
        };
    }
  };

  const { icon: Icon, label, className: statusClassName } = getStatusConfig();

  return (
    <span className={`inline-flex items-center space-x-1 px-2 py-1 rounded-full text-xs font-medium border ${statusClassName} ${className}`}>
      <Icon className="w-3 h-3" />
      <span>{label}</span>
    </span>
  );
};